import React from 'react';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { formatCurrency } from '@/lib/format';
import { months } from '@/data/mockData';
import { ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid, Legend } from 'recharts';

const Forecast = () => {
  const { t, lang, data } = useApp();

  return (
    <div>
      <PageHeader title={t('forecast.title')} subtitle={t('forecast.subtitle')} />
      <Card className="p-6" data-testid="forecast-chart">
        <div className="flex flex-wrap gap-4 mb-4">
          <Legend2 color="#18181B" label={t('forecast.actual')} />
          <Legend2 color="#06B6D4" label={t('forecast.forecast')} dashed />
          <Legend2 color="#10B981" label={t('forecast.target')} dashed />
        </div>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data.forecast} margin={{ left: -5, right: 10, top: 10 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f1f3" vertical={false} />
              <XAxis dataKey="i" tickFormatter={(i) => months[lang][i]} tick={{ fontSize: 11, fill: '#a1a1aa' }} axisLine={false} tickLine={false} />
              <YAxis tickFormatter={(v) => `${Math.round(v / 1000)}k`} tick={{ fontSize: 11, fill: '#a1a1aa' }} axisLine={false} tickLine={false} />
              <Tooltip formatter={(v) => v == null ? '—' : formatCurrency(v, lang)} contentStyle={{ borderRadius: 12, border: '1px solid #e4e4e7', fontSize: 12 }} labelFormatter={(i) => months[lang][i]} />
              <Line type="monotone" dataKey="target" stroke="#10B981" strokeWidth={2} strokeDasharray="5 4" dot={false} />
              <Line type="monotone" dataKey="forecast" stroke="#06B6D4" strokeWidth={2} strokeDasharray="5 4" dot={false} />
              <Line type="monotone" dataKey="actual" stroke="#18181B" strokeWidth={3} dot={{ r: 3 }} connectNulls={false} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};

const Legend2 = ({ color, label, dashed }) => (
  <div className="flex items-center gap-2 text-sm text-zinc-600">
    <span className="w-6 h-0.5 rounded" style={{ background: dashed ? 'transparent' : color, borderTop: dashed ? `2px dashed ${color}` : 'none' }} />
    {label}
  </div>
);

export default Forecast;
